import { useEffect, useState } from "react";
import { Building2, Users, Coins, CheckCircle2, Clock, ShieldQuestion, Layers } from "lucide-react";
import { saas, errMsg } from "@/lib/saasApi";

function Stat({ icon: Icon, label, value, sub }) {
  return (
    <div className="rounded-2xl border border-re-line bg-white p-5" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex items-center gap-2 text-re-muted"><Icon className="h-4 w-4 text-re-red" /><span className="text-sm">{label}</span></div>
      <p className="mt-2 font-heading text-3xl font-bold text-re-charcoal">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-re-muted">{sub}</p>}
    </div>
  );
}

export default function AdminOverview() {
  const [o, setO] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { saas.adminOverview().then(({ data }) => setO(data)).catch((e) => setError(errMsg(e))); }, []);

  if (error) return <p className="text-sm text-re-red" data-testid="overview-error">{error}</p>;
  if (!o) return <p className="text-sm text-re-muted">Loading…</p>;

  return (
    <div className="space-y-6" data-testid="admin-overview">
      <h1 className="font-heading text-2xl font-bold text-re-charcoal">Overview</h1>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat icon={Building2} label="Active customers" value={o.activeOrganisations} />
        <Stat icon={Users} label="Customer users" value={o.customerUsers} />
        <Stat icon={Layers} label="Real Estate Pro projects" value={o.projectsProcessing + o.projectsCompleted + o.projectsReview} sub="Created on this platform" />
        <Stat icon={Coins} label="Available credits" value={o.creditsAvailable} sub="Across all customers" />
        <Stat icon={Layers} label="Credits used" value={o.creditsUsed} />
        <Stat icon={Clock} label="Processing" value={o.projectsProcessing} />
        <Stat icon={CheckCircle2} label="Completed" value={o.projectsCompleted} />
        <Stat icon={ShieldQuestion} label="Under review" value={o.projectsReview} />
      </div>
      <div className="rounded-2xl border border-re-line bg-white p-5" data-testid="pool-estimate">
        <p className="text-sm font-semibold text-re-charcoal">Estimated Rendy balance</p>
        <p className="mt-1 text-sm text-re-muted">This balance is maintained locally and is not directly synchronised with the official Rendy account.</p>
        <p className="mt-3 font-heading text-2xl font-bold text-re-charcoal">{o.providerPoolBalance ?? 0} <span className="text-sm font-medium text-re-muted">estimated listings</span></p>
        <p className="mt-0.5 text-xs text-re-muted">Last reconciliation: {o.providerPoolSyncedAt ? new Date(o.providerPoolSyncedAt).toLocaleString("en-GB") : "never"}</p>
      </div>
    </div>
  );
}
